"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Timer = /** @class */ (function () {
    function Timer(timeout, handler) {
        this.timeout = timeout;
        this.handler = handler;
    }
    Timer.prototype.schedule = function () {
        this.timer = setTimeout(this.handler, this.timeout);
    };
    Timer.prototype.cancel = function () {
        clearTimeout(this.timer);
    };
    return Timer;
}());
exports.default = Timer;
//# sourceMappingURL=timer.js.map